
import { useState } from 'react';

interface KBHeroProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  totalArticles: number;
}

export default function KBHero({ searchQuery, onSearchChange, totalArticles }: KBHeroProps) {
  const [focused, setFocused] = useState(false);

  return (
    <section
      className="relative pt-32 pb-24 overflow-hidden"
      style={{
        backgroundImage:
          'url(/img/stib/setor-tecnologia.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white text-sm font-body px-4 py-2 rounded-full mb-6 backdrop-blur-sm">
          <i className="ri-book-open-line text-primary" aria-hidden="true"></i>
          <span>{totalArticles} articles available</span>
        </div>
        <h1 className="font-heading font-bold text-5xl md:text-6xl text-white mb-6 leading-tight">
          Knowledge Base &amp;<br />
          <span className="text-primary">Technical Guides</span>
        </h1>
        <p className="font-body text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Everything you need to set up, operate, and troubleshoot our silent conference technology — from technical specs to step-by-step guides.
        </p>

        {/* Search Bar */}
        <div
          className={`relative max-w-xl mx-auto transition-all duration-300 ${
            focused ? 'scale-105' : 'scale-100'
          }`}
        >
          <div className="w-5 h-5 flex items-center justify-center absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
            <i className="ri-search-line text-lg" aria-hidden="true"></i>
          </div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            placeholder="Search specs, guides, troubleshooting..."
            className="w-full pl-12 pr-5 py-4 rounded-2xl bg-white text-gray-800 font-body text-sm shadow-2xl focus:outline-none focus:ring-2 focus:ring-primary"
            aria-label="Search knowledge base"
          />
          {searchQuery && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
              aria-label="Clear search"
            >
              <i className="ri-close-line text-lg" aria-hidden="true"></i>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
